import { render, staticRenderFns } from "./planets-menu.svg.vue?vue&type=template&id=33af1244&"
import script from "./planets-menu.svg.vue?vue&type=script&lang=js&"
export * from "./planets-menu.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports